module.exports = __webpack_public_path__ + "static/media/amex.68db3e06.png";